import { ReactNode } from "react";
import { useDarkMode } from "../../hooks/use-dark-mode";
import Header from "./Header";
import Footer from "./Footer";
import Notification from "../common/Notification";

interface AppLayoutProps {
  children: ReactNode;
}

export default function AppLayout({ children }: AppLayoutProps) {
  const { isDarkMode } = useDarkMode();

  return (
    <div className="flex min-h-screen flex-col bg-white text-gray-800 transition-colors duration-200 dark:bg-gray-900 dark:text-gray-200">
      <Header />
      <main className="flex-1">
        {children}
      </main>
      <Footer />
      <Notification />
    </div>
  );
}
